import { render, staticRenderFns } from "./DashboardMemoItem.vue?vue&type=template&id=3b21eecb&scoped=true&"
import script from "./DashboardMemoItem.vue?vue&type=script&lang=js&"
export * from "./DashboardMemoItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMemoItem.vue?vue&type=style&index=0&id=3b21eecb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21eecb",
  null
  
)

export default component.exports